import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormFields } from '~/components/FormFields'
import SimpleFileUpload from '~/components/SimpleFileUpload'

interface Props {
  index: number
  activeIndex: number
}

const LanguageTab: React.FC<Props> = ({ index, activeIndex }) => {
  const { t } = useTranslation()
  const { control, getValues, setValue } = useFormContext()

  const watchFileType = useWatch({ control, name: `languages[${index}].type` })

  const FILE_TYPE_OPTIONS = [
    { key: 'file', value: 'file', text: t('File') },
    { key: 'link', value: 'link', text: t('Link') }
  ]

  function renderFileFields(index, langAdded) {
    return <>
      <FormFields.Input
        control={control}
        label={t('File title')}
        placeholder={t('File title')}
        rules={{
          required: {
            value: true,
            message: t('Please enter title')
          },
          maxLength: {
            value: 100,
            message: t('Max char. is 100')
          }
        }}
        name={`languages[${index}].title`}
      />
      <FormFields.External
        control={control}
        label={t('File')}
        rules={{
          required: {
            value: true,
            message: t('Please upload a file')
          }
        }}
        keyName={getValues(`languages[${index}]`)}
        onChange={(file: File) => {
          setValue(`languages[${index}].file`, file)
        }}
        id={getValues('id') || `languages[${index}].file`}
        name={langAdded ? `languages[${index}].filename` : `languages[${index}].file`}
      >
        <SimpleFileUpload
          activeTabIndex={parseInt(activeIndex.toString())}
          sizeLimitInMB={300}
        />
      </FormFields.External>
    </>
  }

  function renderLinkFields(index) {
    return <>
      <FormFields.Input
        control={control}
        label={t('File title')}
        placeholder={t('File title')}
        rules={{
          required: {
            value: true,
            message: t('Please enter title')
          },
          maxLength: {
            value: 100,
            message: t('Max char. is 100')
          }
        }}
        name={`languages[${index}].title`}
      />
      <FormFields.Input
        control={control}
        label={t('Link')}
        placeholder={t('Enter Link')}
        rules={{
          required: {
            value: true,
            message: t('Please enter link')
          }
        }}
        name={`languages[${index}].link`}
      />
    </>
  }

  const langAdded = getValues(`languages[${index}].filename`) && getValues('id')

  return <>
    <FormFields.Select
      selection
      control={control}
      clearable
      label={t('File type')}
      placeholder={t('Select type')}
      options={FILE_TYPE_OPTIONS}
      name={`languages[${index}].type`}
      rules={{
        required: t('Please select file type')
      }}
    />
    {watchFileType === 'file' && renderFileFields(index, langAdded)}
    {watchFileType === 'link' && renderLinkFields(index)}
  </>
}
export default LanguageTab